import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Card, Grid, Input, Dropdown, Button} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {parseDealers, parseAgencies, parseDate} from '../../../common/util/options';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {returnsStatus} from '../../../common/dictionaries/parameters';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Records from './records';
import NewButton from './newButton';
import './list.scss';

class PartsDevolution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'status': 'all',
      'orderNumber': '',
      'contact': '',
      'startDate': '',
      'endDate': '',
      'dealer': props.isUserFromTDE ? '' : props.userDealer,
      'agency': props.isUserFromTDE ? '' : props.userAgency,
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PartsReturns, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.fetchDealers('importers');
    this.props.getAllAgencies();
    this.props.clearPartsReturnOrders();
  }

  parseStatus() {
    const options = [{'text': 'TODOS', 'value': 'all'}];

    Object.keys(returnsStatus).forEach((status) => {
      options.push({'text': returnsStatus[status], 'value': status});
    });

    return options;
  }
  
  handleSelection(event, {name, value}) {
    this.setState({[name]: value});
  }

  handleChange(event, {name, value}) {
    this.setState({[name]: value.trim().toUpperCase()});
  }

  handleStartDateChange(value) {
    const {endDate} = this.state;
    const dates = {
      endDate,
      'startDate': value ? moment(value).format(noTimeZoneShortISODate) : '',
    };

    if (endDate && moment(endDate) < value) {
      dates.endDate = '';
    }

    this.setState(dates);
  }

  handleEndDateChange(value) {
    this.setState({'endDate': value ? moment(value).format(noTimeZoneShortISODate) : ''});
  }

  handleSearch() {
    const {status, orderNumber, startDate, endDate, contact, dealer, agency} = this.state;
    
    this.props.getPartsReturnOrders({
      orderNumber,
      startDate,
      endDate,
      contact,
      dealer,
      agency,
      'status': status === 'all' ? '' : status,
    });
  }

  handleExport() {
    const {status, orderNumber, startDate, endDate, contact, dealer, agency} = this.state;
    
    this.props.exportPartsReturnOrders({
      orderNumber,
      startDate,
      endDate,
      contact,
      dealer,
      agency,
      'status': status === 'all' ? '' : status,
    });
  }

  renderExportButton() {
    const {isUserFromTDE, loading} = this.props;

    if (!isUserFromTDE) {
      return null;
    }

    return (
      <Button color='green' content='EXPORTAR' disabled={loading} onClick={this.handleExport} />
    );
  }

  renderDealerFilter() {
    const {isUserFromTDE, loadingCustomers, dealers} = this.props;
    const {dealer} = this.props;

    if (!isUserFromTDE) {
      return (<Grid.Column />);
    }

    return (
      <Grid.Column>
        <label><strong>Concesionario</strong></label>
        <Dropdown fluid selection
          name='dealer'
          value={dealer}
          options={parseDealers(dealers)}
          disabled={loadingCustomers}
          onChange={this.handleSelection}
        />
      </Grid.Column>
    );
  }

  renderAgencyFilter() {
    const {isUserFromTDE, loadingCustomers, agencies} = this.props;
    const {dealer, agency} = this.state;

    if (!isUserFromTDE) {
      return (<Grid.Column />);
    }

    return (
      <Grid.Column>
        <label><strong>Agencia</strong></label>
        <Dropdown fluid selection
          name='agency'
          value={agency}
          options={parseAgencies(agencies, dealer)}
          disabled={loadingCustomers || !dealer}
          onChange={this.handleSelection}
        />
      </Grid.Column>
    );
  }

  render() {
    const {startDate, endDate, status, orderNumber, contact} = this.state;
    const {loading} = this.props;

    return (
      <div className='parts-returns'>
        <Card raised fluid className='title-section'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='12' textAlign='left'>
                <h2>Devolución de Pedidos</h2>
              </Grid.Column>
              <Grid.Column width='4' textAlign='right'>
                {this.renderExportButton()}
                <NewButton />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4} textAlign='left'>
              <Grid.Column>
                <label><strong>Fecha Desde</strong></label>
                <DatePicker
                  locale='es'
                  customInput={<Input fluid icon='calendar' />}
                  dateFormat={dateFormatPicker}
                  selected={parseDate(startDate)}
                  onChange={this.handleStartDateChange}
                />
              </Grid.Column>
              <Grid.Column>
                <label><strong>Fecha Hasta</strong></label>
                <DatePicker
                  locale='es'
                  customInput={<Input fluid icon='calendar' />}
                  minDate={parseDate(startDate)}
                  dateFormat={dateFormatPicker}
                  selected={parseDate(endDate)}
                  onChange={this.handleEndDateChange}
                />
              </Grid.Column>
              <Grid.Column>
                <label><strong>Estado</strong></label>
                <Dropdown fluid selection
                  name='status'
                  options={this.parseStatus()}
                  value={status}
                  onChange={this.handleSelection}
                />
              </Grid.Column>
              <Grid.Column>
                <label><strong>No. Orden</strong></label>
                <Input fluid
                  name='orderNumber'
                  maxLength='20'
                  value={orderNumber}
                  onChange={this.handleChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4} textAlign='left'>
              <Grid.Column>
                <label><strong>Contacto</strong></label>
                <Input fluid
                  name='contact'
                  maxLength='60'
                  value={contact}
                  onChange={this.handleChange}
                />
              </Grid.Column>
              {this.renderDealerFilter()}
              {this.renderAgencyFilter()}
              <Grid.Column textAlign='right' verticalAlign='bottom'>
                <Button primary
                  content='BUSCAR'
                  disabled={loading}
                  onClick={this.handleSearch}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Records />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'userDealer': state.session.dealerId,
    'userAgency': state.session.dealerAgency,
    'loading': state.partsReturnsOrders.loading,
    'loadingCustomers': state.dealer.loading || state.dealer.loadingAgencies,
    'dealers': state.dealer.list,
    'agencies': state.dealer.agencies,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchDealers,
  getAllAgencies,
  getPartsReturnOrders,
  clearPartsReturnOrders,
  exportPartsReturnOrders,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchDealers,
  getAllAgencies,
  getPartsReturnOrders,
  clearPartsReturnOrders,
  exportPartsReturnOrders,
})(PartsDevolution);
